import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'

import preferencesUnitModule from '@thomasphan/vue-components/src/store/preferencesUnit'

Vue.use(Vuex)

const vuexLocal = new VuexPersistence
({
  storage: window.localStorage
})

export default new Vuex.Store({
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    preferencesUnitModule
  },
  plugins:
  [
    vuexLocal.plugin
  ],
})
